function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.276 10.593l6.761-6.761-.942-.943L3.333 9.65v.943h.943zm.553 1.334H2v-2.83l7.623-7.623a.667.667 0 01.943 0l1.886 1.886a.667.667 0 010 .943l-7.623 7.624zM2 13.26h12v1.333H2V13.26z",
  fill: "#36443A"
});

function SvgEditLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMjc2IDEwLjU5MzJMMTEuMDM3MyAzLjgzMTgyTDEwLjA5NDcgMi44ODkxNUwzLjMzMzMzIDkuNjUwNDlWMTAuNTkzMkg0LjI3NlpNNC44Mjg2NyAxMS45MjY1SDJWOS4wOTc4Mkw5LjYyMzMzIDEuNDc0NDlDOS43NDgzNSAxLjM0OTUxIDkuOTE3ODkgMS4yNzkzIDEwLjA5NDcgMS4yNzkzQzEwLjI3MTQgMS4yNzkzIDEwLjQ0MSAxLjM0OTUxIDEwLjU2NiAxLjQ3NDQ5TDEyLjQ1MiAzLjM2MDQ5QzEyLjU3NyAzLjQ4NTUxIDEyLjY0NzIgMy42NTUwNSAxMi42NDcyIDMuODMxODJDMTIuNjQ3MiA0LjAwODYgMTIuNTc3IDQuMTc4MTQgMTIuNDUyIDQuMzAzMTVMNC44Mjg2NyAxMS45MjY1Wk0yIDEzLjI1OThIMTRWMTQuNTkzMkgyVjEzLjI1OThaIiBmaWxsPSIjMzY0NDNBIi8+Cjwvc3ZnPgo=";
export { SvgEditLine as ReactComponent };